import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
      data-product-shop
    >
      <div className="relative overflow-hidden aspect-[3/4]">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 韩国漫画无删减下拉式阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '已完结'
              ? 'bg-accent-500 text-background-50'
              : 'bg-primary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="font-medium">{comic.rating}</span>
            <span className="mx-1 opacity-50">|</span>
            <i className="ri-eye-line text-xs"></i>
            <span>{formatViews(comic.views)}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 font-heading">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-foreground-300 text-xs">·</span>
          <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
            {comic.categoryName}
          </span>
        </div>
        <p className="text-xs text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
          {comic.description}
        </p>
      </div>
    </Link>
  );
}